// components/views/Coffee.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';

const Coffee = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const { t } = useTranslation(language);
    
    const handlePayPalClick = () => {
        // Link Ko-fi per foundly
        const kofiLink = 'https://ko-fi.com/foundly';
        window.open(kofiLink, '_blank');
    };

    return (
        <div className="recommend-container">
            <div className="artist-slide">
                <div className="artist-content" style={{ paddingTop: '2rem' }}>
                    <div className="artist-image-container" style={{
                        width: '200px',
                        height: '200px',
                        margin: '0 auto 1rem',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
                    }}>
                        <img 
                            src={`${process.env.PUBLIC_URL}/img/caffe.jpg`} 
                            alt="Coffee" 
                            style={{ 
                                width: '100%', 
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                    
                    <h2 className="artist-name">{t('coffee.title')}</h2>
                    <p className="artist-genres" style={{ marginBottom: '40px' }}>{t('coffee.subtitle')}</p>

                    <div className="artist-bio" style={{ marginTop: '30px' }}>
                        <p>
                            {t('coffee.description1')}
                        </p>
                    </div>

                    <div className="external-links" style={{ marginTop: '50px' }}>
                        <button 
                            onClick={handlePayPalClick}
                            className="external-link spotify-link"
                            style={{
                                background: '#29abe0', // Ko-fi Blue
                                border: 'none',
                                borderRadius: '25px',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#fff',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '12px',
                                textDecoration: 'none',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 15px rgba(41, 171, 224, 0.3)',
                                margin: '0 auto',
                                width: 'fit-content'
                            }}
                        >
                            <img 
                                src={`${process.env.PUBLIC_URL}/img/ko-fi.png`}
                                alt="Ko-fi"
                                style={{
                                    width: '24px',
                                    height: 'auto',
                                    display: 'block'
                                }}
                            />
                            {t('coffee.donateButton')}
                        </button>
                    </div>

                    <p style={{ 
                        color: 'rgba(255,255,255,0.7)', 
                        fontSize: '14px', 
                        textAlign: 'center', 
                        marginTop: '30px' 
                    }}>
                        {t('coffee.thankYou')}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Coffee;